import * as React from 'react';

import { Card, InputGroup, Button, NonIdealState, Icon} from '@blueprintjs/core';

type SectionProps = {
  name: string,
  children: any,
}

class Section extends React.Component<SectionProps>{
  render() {
    const { name, children } = this.props;
    return (
      <div className="Section">
        <h2>{name}</h2>
        {children}
      </div>
    );
  }
}

const EpisodeThumbnail = ({src}) => {
  return (
    <div className="EpisodeThumbnail">
      <img src={src} />
    </div>
  );
}

const Duration = ({seconds}) => {
  var date = new Date(null);
  date.setSeconds(seconds); // specify value for SECONDS here
  const duration = date.toISOString().substr(14, 5).replace(/^0/,'');
  return (
    <div className="_duration">{duration}</div>
  );
}

const Episode = ({name, onClick, isCurrent, thumbnail_url, duration, youtube_id,is_new}) => {
  let className = 'Episode';
  if(isCurrent) className += ' is-current';
  return (
    <div className={className} onClick={onClick}>
      <EpisodeThumbnail src={thumbnail_url} />
      <div className="_content">
        <div className="_title">
          {name}
        </div>
        <Duration seconds={duration} />
        <div className="_labels">
          {youtube_id && <span className="_free">FREE</span>}
          {is_new && <span className="_new">NEW</span>}
        </div>
      </div>
    </div>
  );
}

const SearchBox = ({text, onChange}) => {
  const rightElement = text != '' ? 
    <Button text="Clear" onClick={() => onChange('')} /> 
    : null;

  return (
    <InputGroup leftIcon="search" 
      onChange={(e) => onChange(e.target.value)} 
      value={text}  
      className="SearchBox"
      placeholder="Search episodes..."
      rightElement={rightElement} />
  );
}

const SearchResults = ({text, children}) => {
  return (
    <div>
      {children || <NonIdealState icon="search" title="No episodes found" /> }
    </div>
  );
}

type ContentsProps = {
  course: any,
  current: any,
  onChange: Function,
}
export default class Contents extends React.Component<ContentsProps> {
  state = {
    searchText: "",
  }

  handleSearchChange = (value) => {
    this.setState({
      searchText: value,
    });
  }

  getAllEpisodes = () => {
    const { course } = this.props;
    return [].concat.apply([], course.sections.map( section => section.episodes ));
  }

  getFilteredEpisodes = () => {
    const { searchText } = this.state;

    return this.getAllEpisodes().filter( el => el.name.toLowerCase().indexOf(searchText.toLowerCase()) != -1 );
  }

  render() {
    const { course, onChange, current } = this.props;
    const { searchText } = this.state;
    const isSearching = searchText.trim() != '';
    const summary = {
      duration: course.duration,
      count: this.getAllEpisodes().length,
    }
    

    return (
      <div className="Contents">
        <div className="_summary">
        {summary.count} episodes / {Math.round(summary.duration / 3600)}h{Math.round((summary.duration % 3600) / 60)}m
        </div>
        <SearchBox text={searchText} onChange={this.handleSearchChange} />

        { isSearching && 
          <SearchResults text={searchText}>
            {this.getFilteredEpisodes().map( episode => 
              <Episode {...episode} 
                key={episode.id}
                isCurrent={episode == current}
                onClick={ () => onChange(episode) } />
             )}
          </SearchResults>}

        { !isSearching && course.sections.map( section => 
          <Section {...section} key={section.id}>
            {section.episodes.map( episode  => 
              <Episode {...episode} 
                key={episode.id}
                isCurrent={episode == current}
                onClick={ () => onChange(episode) } />

            )}
          </Section>
        )} 
      </div>
    )
  }
}
